export const TancisRoutes = [
    {
        name: "Cargo Management",
        base: process.env.REACT_APP_BASE_CGM,
        children: [
            {
                name: "Manifest Management",
                base: "CGM02",
                children: [
                    {
                        name: "Repacking BL",
                        base: "CGM02S12",
                        children: [
                            {
                                name: "Repacking BL (with Item)",
                                to: "/cgme/wrhs/rpck/cgme0411001q",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: "Single Window",
        base: process.env.REACT_APP_BASE_PTL,
        children: [
            {
                name: "HS Code",
                base: "",
                children: [
                    {
                        name: "Verification",
                        base: "",
                        children: [
                            {
                                name: "Verification List",
                                to: "/ptli/esw/hs/vrfn/eswi0101001q",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: "Portal Management",
        base: process.env.REACT_APP_BASE_PTL,
        children: [
            {
                name: "User Accreditation",
                base: "acrdt",

                children: [
                    {
                        name: "User Registration Apply",
                        to: "",
                        children: [
                            {
                                name: "User Registration Apply",
                                to: "/ptli/acrdt/newusr/ptli0205001s/intUsrRgst",
                            },
                        ],
                    },
                ],
            },

            {
                name: "My Page",
                base: "mypage",

                children: [
                    {
                        name: "My To-Do",
                        to: "",
                        children: [
                            {
                                name: "My To-Do",
                                to: "/ptli/mypage/todo/ptli0301001q",
                            },
                        ],
                    },
                    {
                        name: "Notification",
                        to: "/ptli/mypage/notihist/ptli0308001q?menuId=menu_ptli0008",
                    },
                    {
                        name: "Change My Information",
                        to: "/ptli/mypage/myinfochg/ptli0307001s/usrDmnId",
                    },
                ],
            },
            {
                name: "Common Module",
                base: "comnmdle",

                children: [
                    {
                        name: "Code Management",
                        to: "",
                        children: [
                            {
                                name: "Common Code Management",
                                to: "/ptli/comnmdle/comncd/ptli0404001q",
                            },
                            {
                                name: "Country Code Management",
                                to: "/ptli/comnmdle/cntycd/ptli0414001q?menuId=menu_ptli0056",
                            },
                            {
                                name: "Region Code Management",
                                to: "/ptli/comnmdle/regncd/ptli0415001q?menuId=menu_ptli0057",
                            },
                            {
                                name: "Currency Code Management",
                                to: "/ptli/comnmdle/curr/ptli0416001q",
                            },
                        ],
                    },
                    {
                        name: "Document Management",
                        to: "",
                        children: [
                            {
                                name: "Pre-Verification Document Management",
                                to: "/ptli/comnmdle/doc/ptli0412001q",
                            },
                            {
                                name: "Pre-Verification Management by Document",
                                to: "/ptli/comnmdle/doc/ptli0413001q",
                            },
                        ],
                    },
                    {
                        name: "Approval Line Management",
                        to: "",
                        children: [
                            {
                                name: "Approval Line Management",
                                to: "/ptli/comnmdle/aprvpath/ptli0409001q",
                            },
                            {
                                name: "Approval Status",
                                to: "/ptli/comnmdle/aprv/ptli0409004q",
                            },
                        ],
                    },
                ],
            },

            {
                name: "User Management",
                base: "usr",

                children: [
                    {
                        name: "Company Management",
                        base: "coaprv",
                        children: [
                            {
                                name: "Company Approval Request Management",
                                to: "/ptli/usr/coaprv/ptli0915001q",
                            },
                        ],
                    },
                    {
                        name: "Customs",
                        base: "cstm",
                        children: [
                            {
                                name: "Customs Management",
                                to: "/ptli/usr/cstm/ptli0901001q",
                            },
                            {
                                name: "Customs Officer management",
                                to: "/ptli/usr/cstmofcr/ptli0902001q",
                            },
                            {
                                name: "Customs Officer Change History Management",
                                to: "/ptli/usr/ofcrhist/ptli0904001q",
                            },
                            {
                                name: "Organizations Management",
                                to: "/ptli/usr/orgz/ptli0912001q",
                            },
                        ],
                    },
                    {
                        name: "Organization Management",
                        base: "org",
                        children: [
                            {
                                name: "Organization Management",
                                to: "/ptli/usr/org/ptli0916001q",
                            },
                            {
                                name: "Organization User Management",
                                to: "/ptli/usr/orgusr/ptli0917001q?menuId=menu_ptlo0017",
                            },
                        ],
                    },
                    {
                        name: "License User Management",
                        base: "lcneusr",
                        children: [
                            {
                                name: "License User Aply",
                                to: "/ptli/usr/lcneusr/ptli0906001q",
                            },
                            {
                                name: "License User Aply Approval",
                                to: "/ptli/usr/lcneusraprv/ptli0907001q",
                            },
                        ],
                    },
                    {
                        name: "Foreign Transporter List",
                        base: "lcneusr",
                        children: [
                            {
                                name: "Foreign Transporter List",
                                to: "/ptli/usr/frgnr/ptli0919001s?menuId=menu_ptli0039",
                            },
                        ],
                    },
                    {
                        name: "Bidder User Management",
                        base: "bidrUsr",
                        children: [
                            {
                                name: "Bidder User Management",
                                to: "/ptli/usr/bidrusr/ptli0911001q?menuId=menu_ptli0038",
                            },
                        ],
                    },
                    {
                        name: "External User Management",
                        base: "xtrnUsr",
                        children: [
                            {
                                name: "External User Management",
                                to: "/ptli/usr/xtrnusr/ptli0922001q?menuId=menu_ptli0319",
                            },
                        ],
                    },
                ],
            },

            {
                name: "Interal Portal Management",
                base: "ptl",
                children: [
                    {
                        name: "Role Management",
                        base: "role",
                        children: [
                            {
                                name: "Role Management",
                                to: "/ptli/ptl/role/ptli1004001q?Id=_ptli0039",
                            },
                            {
                                name: "Auth Management",
                                to: "/ptli/ptl/role/ptli1005001q",
                            },
                        ],
                    },
                    {
                        name: "Menu Management",
                        base: "",
                        children: [
                            {
                                name: "Menu Management",
                                to: "/ptli/ptl/menu/ptli1001001q",
                            },
                            {
                                name: "Screen Management",
                                to: "/ptli/ptl/menu/ptli1002001q",
                            },
                            {
                                name: "Menu and Screen",
                                to: "/ptli/ptl/menu/ptli1003001q",
                            },
                        ],
                    },
                    {
                        name: "Label Management",
                        base: "lbl",
                        children: [
                            {
                                name: "Multi Language(Label)",
                                to: "/ptli/ptl/lbl/ptli1014001q",
                            },
                        ],
                    },
                    {
                        name: "Community",
                        base: "cmnty",
                        children: [
                            {
                                name: "전자민원 처리 관리",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0007",
                            },
                            {
                                name: "전체 공지사항",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0078",
                            },
                            {
                                name: "개별 공지사항",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0079",
                            },
                            {
                                name: "정부 공지사항",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0080",
                            },
                            {
                                name: "Q&A",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0081",
                            },
                            {
                                name: "자료실",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0082",
                            },
                            {
                                name: "FAQ",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0083",
                            },
                            {
                                name: "My IQS",
                                to: "/ptli/mypage/myiqs/ptli0304001q?menuId=menu_ptli0006",
                            },
                        ],
                    },
                    {
                        name: "Bulletin board Management",
                        base: "bltbrd",
                        to: "/ptli/ptl/bltbrd/ptli1017001q?menuId=menu_ptli0084",
                    },
                    {
                        name: "User Guide",
                        base: "usrguide",
                        to: "/ptli/ptl/manl/ptli0411001q?menuId=menu_ptli0086",
                    },
                ],
            },
            {
                name: "Batch Management",
                base: "btch",

                children: [
                    {
                        name: "Batch Management",
                        to: "",
                        children: [
                            {
                                name: "Batch Information Management",
                                to: "/ptli/btch/info/ptli1201001q",
                            },
                            {
                                name: "Schedule Management",
                                to: "/ptli/btch/schd/ptli1202001q",
                            },
                            {
                                name: "Batch Execution Management",
                                to: "/ptli/btch/excutn/ptli1203001q",
                            },
                            {
                                name: "Batch Execution Result Management",
                                to: "/ptli/btch/excutnrslt/ptli1204001q",
                            },
                        ],
                    },
                ],
            },

            {
                name: "Criteria Information Management",
                base: "crtr",

                children: [
                    {
                        name: "Exchange Rate Management",
                        to: "",
                        children: [
                            {
                                name: "Exchange Rate Management",
                                to: "/ptli/crtr/exrt/ptli0405001q?menuId=menu_ptli0060",
                            },
                        ],
                    },

                    {
                        name: "Holiday Management",
                        to: "",
                        children: [
                            {
                                name: "Holiday Management",
                                to: "/ptli/crtr/hldy/ptli0408001q?menuId=menu_ptli0061",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Electronic Document Management",
                base: "elctdoc",
                children: [
                    {
                        name: "Electronic Document Reception Management",
                        to: "/ptli/elctdoc/rcpn/ptli0701001q",
                    },
                    {
                        name: "Electronic Document Transmission Management",
                        to: "/ptli/elctdoc/trmssn/ptli0702001q",
                    },
                    {
                        name: "Document Box Management",
                        to: "/ptli/elctdoc/box/ptli0703001q",
                    },
                    {
                        name: "UCR Reception Management",
                        to: "/ptli/elctdoc/ucr/ptli0704001q",
                    },
                    {
                        name: "Channel Management",
                        to: "/ptli/elctdoc/chnl/ptli0705001q",
                    },
                    {
                        name: "Gateway Management",
                        to: "/ptli/elctdoc/gway/ptli0706001q",
                    },
                    {
                        name: "Interface History Management",
                        to: "/ptli/elctdoc/hist/ptli0707001q",
                    },
                ],
            },

            {
                name: "System Management",
                base: "sysm",

                children: [
                    {
                        name: "Drd Criteria Management Infomaion",
                        to: "",
                        children: [
                            {
                                name: "Drd Criteria Management Infomaion",
                                to: "/ptli/sysm/drdctra/ptli0406001s?menuId=menu_ptli0071",
                            },
                        ],
                    },
                    {
                        name: "Notifice Management",
                        to: "",
                        children: [
                            {
                                name: "Notifice Management",
                                to: "/ptli/ptl/noti/ptli1010001q?menuId=menu_ptli0072",
                            },
                        ],
                    },
                    {
                        name: "Template Management",
                        to: "",
                        children: [
                            {
                                name: "Template Management",
                                to: "/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0087",
                            },
                        ],
                    },
                ],
            },

            {
                name: "Monitoring processing status",
                base: "prcsmntr",

                children: [
                    {
                        name: "Monitoring processing status",
                        to: "",
                        children: [
                            {
                                name: "Internal user account processing status",
                                to: "/ptli/prcsmntr/intusr/ptli0601001q",
                            },
                            {
                                name: "External user account processing status",
                                to: "/ptli/prcsmntr/xtrnusr/ptli0602001q",
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
